import React from 'react';
import { connect } from 'react-redux';

import { login } from '../../redux/actions/Login';
// Styles
import '../../../../common/css/form.css';

// Components
import {
  Form,
  // Select,
  Button,
  Menu,
  Dropdown,
  Icon,
} from 'antd';
import { restoreLogin } from '../../redux/actions/RestoreLogin';
import { unsetActiveProfile } from '../../redux/actions/ProfileList';
import LoginPhoneInput from '../../../../common/inputs/AuthorizationInputs';

// Validation rules
import { hasCorrectLength } from '../../../../common/utils/validation';

// const Option = Select.Option;
const FormItem = Form.Item;

// import SendPhoneForm from './SendPhoneForm';
// import SendEmailForm from './SendEmailForm';

const phoneCodes = [
  {
    code: '+7',
    country: 'Россия',
  },
  {
    code: '+380',
    country: 'Украина',
  },
  {
    code: '+375',
    country: 'Беларусь',
  },
  {
    code: '+77',
    country: 'Казахстан',
  },
  {
    code: '+994',
    country: 'Азербайджан',
  },
  {
    code: '+374',
    country: 'Армения',
  },
  {
    code: '+995',
    country: 'Грузия',
  },
];
class Login extends React.Component {
  state = {
    phoneCode: '+7',
    phoneNumber: '',
    password: '',
    phoneValidationStatus: null,
    phoneErrMsg: '',
  };

  componentDidMount() {
    const { restoreLogin } = this.props;
    restoreLogin();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loginStatus !== this.props.loginStatus) {
      if (
        this.props.loginStatus.errorMsg &&
        this.props.loginStatus.errorMsg !== ''
      ) {
        this.setState(state => ({
          phoneValidationStatus: state.codeValidationStatus = 'error',
          phoneErrMsg: this.props.loginStatus.errorMsg,
        }));
      } else if (this.props.loginStatus.loading) {
        this.setState(state => ({
          phoneValidationStatus: state.codeValidationStatus = 'validating',
        }));
      } else if (this.props.loginStatus.message === 'FAILURE') {
        this.props.unsetActiveProfile();
      }
    }
  }

  validatePhoneNumber(value) {
    if (!hasCorrectLength(10, value)) {
      this.setState({
        phoneValidationStatus: 'error',
        phoneErrMsg: 'Недопустимое количество символов',
      });
      return false;
    } else {
      this.setState({
        phoneValidationStatus: 'success',
        phoneErrMsg: '',
      });
      return true;
    }
  }

  authHandler = e => {
    e.preventDefault();
    let { login } = this.props;
    const form = this.state;
    let code = form.phoneCode.slice(1);
    let number = form.phoneNumber;
    let isValid = this.validatePhoneNumber(number);
    if (isValid) {
      login({ phone: '+' + code + number });
      //registration({ phone: code + number, password });
    }
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render(props) {
    let {
      phoneErrMsg,
      phoneValidationStatus,
      phoneCode,
      phoneNumber,
    } = this.state;
    const menu = (
      <Menu>
        {phoneCodes.map(code => (
          <Menu.Item key={code.code}>
            <span
              onClick={() => {
                const e = {};
                e.target = {};
                e.target.name = 'phoneCode';
                e.target.value = code.code;
                this.handleChange(e);
              }}
              key={code.code}
            >
              {code.code + ` (${code.country})`}
            </span>
          </Menu.Item>
        ))}
      </Menu>
    );
    return (
      <div id="loginForm">
        <div className="login__title">Авторизация</div>
        <Form
          autoComplete="off"
          className="form form_login login__form"
          onSubmit={this.authHandler}
        >
          <div className="form__field form__field_phone">
            <div className="form__field-description">
              Введите номер телефона <br /> для получения кода
              входа/регистрации.
            </div>
            <div className="form__field-input">
              <FormItem style={{ width: '80px' }}>
                <Dropdown
                  trigger={['click']}
                  overlay={menu}
                  placement="bottomCenter"
                >
                  <Button style={{ width: '80px', fontSize: '16px' }}>
                    {phoneCode}
                    <Icon type="down" />
                  </Button>
                </Dropdown>
                {/*<Select*/}
                {/*  dropdownMatchSelectWidth={false}*/}
                {/*  style={{ width: '80px' }}*/}
                {/*  className="form__input multiSelect"*/}
                {/*  dropdownClassName="w-180"*/}
                {/*  name="phoneCode"*/}
                {/*  value={phoneCode}*/}
                {/*  size="large"*/}
                {/*  autoComplete="off"*/}
                {/*  onChange={value => {*/}
                {/*    const e = {};*/}
                {/*    e.target = {};*/}
                {/*    e.target.name = 'phoneCode';*/}
                {/*    e.target.value = value;*/}
                {/*    debugger*/}
                {/*    this.handleChange(e);*/}
                {/*  }}*/}
                {/*>*/}
                {/*  {phoneCodes.map(code => (*/}
                {/*    <Option value={code.code}>{code.code + ` (${code.country})`}</Option>*/}
                {/*  ))}*/}
                {/*</Select>*/}
              </FormItem>
              <FormItem
                validateStatus={phoneValidationStatus}
                help={phoneErrMsg}
                hasFeedback
              >
                <LoginPhoneInput
                  autoComplete="off"
                  className="form__input"
                  name="phoneNumber"
                  size="large"
                  mask="(###) ###-##-##"
                  value={phoneNumber}
                  maxLength={15}
                  placeholder="Номер телефона"
                  onChange={this.handleChange}
                />
              </FormItem>
            </div>
          </div>
          {this.props.children}
          <div className="form__button">
            <Button
              className="form__button-get-code"
              htmlType="submit"
              size="large"
              style={{ width: '100%' }}
              type="primary"
            >
              Авторизоваться
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default connect(
  state => ({
    loginStatus: state.Authorization.status.loginStatus,
    restoreLoginStatus: state.Authorization.status.restoreLoginStatus,
  }),
  {
    login,
    restoreLogin,
    unsetActiveProfile,
  }
)(Login);
